// ======================================================================
// File Name       : SelectBoxData
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { IS_SHOW_MENU_DEVELOP_FEATURE_51, ROOT_URL } from '../constants/index';

// SelectBox data
export const SELECT_BOX_DATA = {
  CONTENT_TYPE: [
    // コンテンツ種別
    { name: null, value: null },
    { name: 'ビデオ', value: 0 },
    { name: 'ドリル', value: 1 },
    { name: '問題', value: 2 },
    { name: 'ドキュメント', value: 3 },
    { name: 'リンク', value: 5 },
  ],
  CONTENT_TYPE_NOT_QUESTION: [
    // コンテンツ種別
    { name: null, value: null },
    { name: 'ビデオ', value: 0 },
    { name: 'ドリル', value: 1 },
    { name: 'ドキュメント', value: 3 },
    { name: 'リンク', value: 5 },
  ],
  PUBLIC_STATUS: [
    // 公開ステータス
    { name: '非公開', value: 0 },
    { name: '公開', value: 1 },
  ],
  PUBLIC_STATUS_ENTERPRISE_NOTIFICATION: [
    { name: null, value: null },
    { name: '非公開', value: 0 },
    { name: '公開', value: 1 },
  ],
  END_CONDITION_TYPE_FOR_COURSE: [
    // コース完了条件
    { name: null, value: null },
    { name: '条件なし(完了しない)', value: 0 },
    { name: '進捗率', value: 1 },
    { name: '理解度', value: 2 },
    { name: '進捗率 OR 理解度', value: 3 },
    { name: '理解度 AND 理解度', value: 4 },
  ],
  // #6466 START
  SAMPLE_DOWNLOAD: [
    {
      name: 'サンプルコンテンツダウンロード',
      value: `${ROOT_URL}/manual/samplecontents.zip`,
    },
    {
      name: 'サポートツールダウンロード',
      value: `${ROOT_URL}/manual/SupportTool.zip` },
  ],
  // #6466 END
  DOCUMENT_UPDATE_STATUS: [
    { name: null, value: null },
    { name: 'アップロード中', value: 0 },
    { name: 'アップロード済', value: 1 },
    { name: 'アップロード失敗', value: 2 },
  ],

  QUESTION_TYPE: [{ name: '単問', value: 0 }, { name: '大問', value: 1 }],
  QUESTION_TYPE_HAVE_BLANK: [{ name: null, value: null }, { name: '単問', value: 0 }, { name: '大問', value: 1 }],
  HOUR: initHour(12),
  MINUTE_SECOND: initHour(59),
  LOCK_TYPE: [{ name: 'アンロック', value: 0 }, { name: 'ロック', value: 1 }],
  DRILL_START_CONDITION: [
      { name: 'はじめから開始', value: 0 },
      { name: 'つづきから開始', value: 1 },
      { name: 'ミス問（前回のミス）スタート', value: 2 },
      { name: 'ミス問（過去のミス）スタート', value: 3 },
      { name: 'お気に入り問題スタート', value: 4 },
  ],
  LIMIT_TIME_ADAPTED_TARGET: [
    { name: null, value: null },
    { name: '制限しない', value: 0 },
    { name: 'ドリル', value: 1 },
    { name: '問題', value: 2 },
  ],
  LIMIT_TIME_OVER_ACTION: [{ name: null, value: null }, { name: '何もしない', value: 0 }, { name: '強制終了', value: 1 }],
  LIMIT_TIME_COUNT_FORM: [
    { name: null, value: null },
    { name: 'カウントアップ', value: 1 },
    { name: 'カウントダウン', value: 2 },
    { name: 'カウントアップバー', value: 3 },
    { name: 'カウントダウンバー', value: 4 },
  ],
  SANKAKU_JUDGE_USE_SET: [{ name: '使用しない', value: 0 }, { name: '使用する', value: 1 }],
  EXPLANATION_AUTO_VIEW: [{ name: '自動で表示しない', value: 0 }, { name: '自動で表示する', value: 1 }],
  ATTENTION_RELATE_SET: [{ name: '表示しない', value: 0 }, { name: '表示する', value: 1 }],
  RESUME_USE_SET: [{ name: '使用しない', value: 0 }, { name: '使用する', value: 1 }],
  SCORE_FORM: [{ name: '正解数表示', value: 0 }, { name: '正答率表示', value: 1 }, { name: '点数表示', value: 2 }],
  MARK_RULE: [
    { name: '絶対配点', value: 0 },
    { name: '点数按分', value: 1 },
    { name: '加重平均配点', value: 2 },
    { name: 'グループ配点', value: 3 },
  ],
  DRILL_LIMIT_TIME_ADAPTED_TARGET: [
    { name: '設定しない', value: 0 },
    { name: 'ドリル', value: 1 },
    { name: '問題', value: 2 },
  ],
  RELEASE_TARGET: [
    { name: '企業内', value: 0 },
    { name: '従属企業全体', value: 1 },
  ],
  AVAILABLE_DISABLE_USAGE: [{ name: '利用なし', value: 0 }, { name: '利用あり', value: 1 }],
  SERVICE_TYPE: [{ name: '通常サービス', value: 0 }, { name: 'コンテンツ配信サービス', value: 2 }],
  PASSWORD_STRENGTH: [{ name: '標準', value: 0 }, { name: '中', value: 1 }, { name: '強', value: 2 }],
  CONTENT_UPDATE_NOTIFICATION: [{ name: '有効', value: 0 }, { name: '無効', value: 1 }],
  GROUP_EDIT_TITLE: [
    { name: 'ユーザーグループ情報の編集', value: 0 },
    { name: 'ユーザーグループに所属する管理ユーザーを選択してください', value: 1 },
    { name: 'ユーザーグループに所属する受講ユーザーを選択してください', value: 2 },
  ],
  DORMANT_STATE: [{ name: '稼働中', value: 0 }, { name: '休止中', value: 1 }],
  VIDEO_STATUS: [
    { name: null, value: null },
    { name: '変換開始前', value: 0 },
    { name: '変換完了（再生可能）', value: 2 },
    { name: '変換中', value: 4 },
    { name: '変換エラー', value: 5 },
    { name: 'アップロードエラー', value: 7 },
    { name: '変換エラー(再生時間上限超過)', value: 8 },
  ],
  CONVERT_STATUS: [
    { name: '変換開始', value: 0 },
    { name: '変換中', value: 1 },
    { name: '変換完了（成功)', value: 2 },
    { name: '変換エラー', value: 3 },
  ],
  CONVERT_STATUS_WITH_NULL: [
    { name: '', value: null },
    { name: '変換開始', value: 0 },
    { name: '変換中', value: 1 },
    { name: '変換完了（成功)', value: 2 },
    { name: '変換エラー', value: 3 },
  ],
  OPTION_MARK_TYPE: [
    { name: null, value: null },
    { name: '1/2/3/・・・', value: 1 },
    { name: '①/②/③/・・・', value: 2 },
    { name: 'A/B/C/・・・', value: 3 },
    { name: 'A/B/C/・・・（丸付き）', value: 4 },
    { name: 'a/b/c/・・・', value: 5 },
    { name: 'a/b/c/・・・（丸付き）', value: 6 },
    { name: 'ア/イ/ウ/・・・', value: 7 },
    { name: 'ア/イ/ウ/・・・（丸付き）', value: 8 },
    { name: 'あ/い/う/・・・', value: 9 },
    { name: 'あ/い/う/・・・（丸付き）', value: 10 },
  ],
  ANSWER_FORMULA: [
    { name: '選択式単一解答', value: 0 },
    { name: '選択式複数解答', value: 1 },
    { name: '選択式並べ替え解答', value: 2 },
    { name: '記述式単一解答', value: 3 },
    { name: '記述式単一解答（複数正答)', value: 4 },
    { name: '記述式複数解答（順不同)', value: 5 },
    { name: '記述式複数解答（順序指定)', value: 6 },
    { name: '記述式単一解答（長文解答)', value: 7 },
  ],
  ANSWER_FORMULA_WITH_NULL: [
    { name: '', value: null },
    { name: '選択式単一解答', value: 0 },
    { name: '選択式複数解答', value: 1 },
    { name: '選択式並べ替え解答', value: 2 },
    { name: '記述式単一解答', value: 3 },
    { name: '記述式単一解答（複数正答)', value: 4 },
    { name: '記述式複数解答（順不同)', value: 5 },
    { name: '記述式複数解答（順序指定)', value: 6 },
    { name: '記述式単一解答（長文解答)', value: 7 },
  ],
  DRILL_STATUS: [
    { name: null, value: null },
    { name: '変換開始', value: 0 },
    { name: '変換中', value: 1 },
    { name: '変換完了（成功）', value: 2 },
    { name: '変換エラー', value: 3 },
  ],
  DRILL_KIND_LIST: [
    { name: null, value: null },
    { name: 'ノーマルモード', value: 0 },
    { name: '再解答モード', value: 1 },
    { name: 'テストモード', value: 2 },
    // { name: '', value: 3 },
    { name: 'アダプティブモード', value: 4 },
    { name: '添削モード', value: 5 },
    { name: 'アンケートモード', value: 6 }, // #7269
  ],
  DISTRIBUTION_AUTHORITY_OPTION: [
    { name: '添削者', value: 1 },
    { name: '添削承認者', value: 2 },
  ],
  RELEASE_TARGET_FOR_ENTERPRISE: [
    { name: null, value: null },
    { name: '自企業内', value: 0 },
    { name: '従属企業全体', value: 1 },
  ],
  USER_TYPE: [
    { name: null, value: null },
    { name: '管理ユーザー', value: 0 },
    { name: '受講ユーザー', value: 2 },
  ],
  USER_TYPE_NO_NULL: [
    { name: '管理ユーザー', value: 0 },
    { name: '受講ユーザー', value: 2 },
  ],
  LIVE_FORMAT_SELECT: [
    { name: '片方向', value: 1 },
    { name: '双方向', value: 0 },
  ],
  DISTRIBUTION_OFFER_TYPE: IS_SHOW_MENU_DEVELOP_FEATURE_51 ? [
    { name: 'コース', value: 0 },
    { name: 'コンテンツ', value: 1 },
  ] : [{ name: 'コンテンツ', value: 1 }],
  ENTERPRISE_PRICE_PLAN: [
    { name: '新料金プラン', value: 1 },
    { name: '旧料金プラン', value: 0 },
  ],
  // #7073 START
  TRANSLATION_LANGUAGE: [
    { name: '英語', value: 'en' },
    { name: '中国語(繁体)', value: 'zh-hant' },
    { name: '中国語(簡体)', value: 'zh-hans' },
    { name: '韓国語', value: 'ko' },
    { name: 'スペイン語', value: 'es' },
    { name: 'フランス語', value: 'fr' },
    { name: 'ベトナム語', value: 'vi' },
    { name: 'タイ語', value: 'th' },
  ],
  TRANSLATION_LANGUAGE_SHORT_NAME: [
    { name: '英', value: 'en' },
    { name: '中繁', value: 'zh-hant' },
    { name: '中簡', value: 'zh-hans' },
    { name: '韓', value: 'ko' },
    { name: '西', value: 'es' },
    { name: '仏', value: 'fr' },
    { name: '越', value: 'vi' },
    { name: '秦', value: 'th' },
  ],
  // #7073 END
  // Step 7.0 No.3 START
  USERFRONT_LANGUAGE_SETTING_TYPE: [
    { name: '日本語', value: '0' },
    { name: '多言語', value: '1' },
  ],
  // Step 7.0 No.3 END

  // sprint_20230403 #4 START
  // sprint_20230508_tma #20 START
  CREDIT_CHECKED_FLAG: [{ name: '未確認', value: 0 }, { name: '問題なし', value: 1 }, { name: '問題あり', value: 2 }],
  // sprint_20230508_tma #20 END
  SERVICE_STOP_FLAG: [{ name: '利用可能', value: false }, { name: '利用停止', value: true }],
  AVAILABLE_DISABLE_USAGE_BOOLEAN_VALUE: [{ name: '利用なし', value: false }, { name: '利用あり', value: true }],
  // sprint_20230508 #27 START
  DORMANT_USER_DATA_ACQUISITION_PERMISSION_FLAG: [{ name: '許可しない', value: false }, { name: '許可する', value: true }],
  // sprint_20230508 #27 END
  AVAILABEL_DISABLE_DISPLAY: [{ name: '表示なし', value: false }, { name: '表示あり', value: true }],
  DOCUMENT_PRINTING_PERMISSION: [{ name: '印刷不可', value: false }, { name: '印刷可能', value: true }],
  DOCUMENT_DOWNLOAD_PERMISSION: [{ name: 'ダウンロード不可', value: false }, { name: 'ダウンロード可能', value: true }],
  SERVICE_CATEGORY: [
    { name: 'デモ', value: 1 },
    { name: 'トライアル', value: 2 },
    { name: 'ミドル', value: 3 },
    { name: 'エンド', value: 4 },
    { name: 'エンド(相対)', value: 5 },
    { name: 'その他', value: 6 },
    { name: '外部連携1', value: 10 },
    { name: '外部連携2', value: 11 },
    { name: '外部連携3', value: 12 },
  ],
  // sprint_20230403 #4 END
  // sprint_20230605_tma START
  PAYMENT_TYPE:[{ name:'カード支払い', value: 0 }, {name:'銀行振込', value: 1 }, {name:'OpS', value: 2 }],
  // sprint_20230605_tma END
  // Step 10.0.0 START
  PROGRESS_STATUS_CSV_TYPE: [
    { name: 'コンテンツ', value: 0 },
    { name: 'セクション', value: 1 },
    { name: 'コース', value: 2 }
  ],
  // Step 10.0.0 END
  // STEP12.0.0 TAS-18197 START
  BACKGROUND_VIDEO_PLAYBACK_FLAG: [{ name: 'バックグラウンド再生停止', value: false }, { name: 'バックグラウンド再生許可', value: true }],
  // STEP12.0.0 TAS-18197 END
  // STEP12.0.0 TAS-18710 START
  MANUAL_PASSWORD_SETTING_FLAG: [{ name: '無効', value: false }, { name: '有効', value: true }],
  // STEP12.0.0 TAS-18710 START
};

export const COURSE_GROUP_RELATION_TYPE_NAME_LIST = [
  { name: '直接', value: 0 },
  { name: '間接', value: 1 },
];


/**
 * Create hour, minute, second values for selectbox
 * @parma: len
*/
function initHour(len) {
  const arr = [];
  for (let i = 0; i <= len; i++) {
    arr.push({ name: i < 10 ? `0${i}` : i, value: i });
  }
  return arr;
}

/**
 * Create number: 10, 20,30,..., 100
 * @parma: len
*/
function initNumber(len) {
  const arr = [{ name: null, value: null }];
  for (let i = 10; i <= len; i += 10) {
    arr.push({ name: i, value: i });
  }
  return arr;
}

function initMutilselectValue(len) {
  const arr = [];
  for (let i = 1; i <= len; i++) {
    arr.push({ name: i, value: i });
  }
  return arr;
}
